// ***************
// src/app/services/autologout.js
// autor: WdePaula / MVinfo
// data: 8/8/24 | 13h53
// data: 30/12/24 | 13h15 | eliminamos o localStorage.clear e individualizamos a remoção
// ***************




export const AutoLogout = () => {
    // localStorage.clear(); // substituída pela linha abaixo 30/12/24w
    localStorage.removeItem("tokenlg");
    localStorage.removeItem("tokenapw");
    localStorage.removeItem("tokenasw");

    sessionStorage.clear();
    window.location.href = "/app/login/prestador";
};
